import React from 'react';
import { Reveal } from './Reveal';
type Volume = {
  number: string;
  title: string;
  description: string;
  tags: string[];
  featured?: boolean;
};
const volumes: Volume[] = [{
  number: 'VOLUME 01',
  title: '🌟 Tarot Decoded: The Complete Therapeutic Reference Guide',
  description: 'All 78 cards decoded with psychological meanings, symbolism, affirmations, elemental and astrological correspondences, therapeutic spread guides, and printable reference charts.',
  tags: ['78 Cards Decoded', 'Spread Guides', 'Printable Charts']
}, {
  number: 'VOLUME 02',
  title: '⚡ Professional Interpretation System: Translating Symbols into Clinical Insights',
  description: 'Systematic interpretation framework, translating symbols into insights, clinical precision protocols, real-time session application, context-based meanings, and practitioner decision trees.',
  tags: ['Interpretation Framework', 'Session Protocols', 'Decision Trees'],
  featured: true
}, {
  number: 'VOLUME 03',
  title: '🔮 The Library of 200 Emotional Exploration Questions',
  description: '200+ power questions organized by emotional territory—grief and loss, relationship and attachment, limiting beliefs, purpose and direction—with question sequencing mastery.',
  tags: ['200+ Power Questions', 'Emotional Territories', 'Sequencing Mastery']
}, {
  number: 'VOLUME 04',
  title: '🌀 Therapeutic Spreads & Methods: Layouts That Create Breakthroughs',
  description: 'Complete spread library with spreads for specific outcomes, how to guide clients through layouts, reading interpretations in context, integration protocols, and ready-to-use templates.',
  tags: ['Complete Spread Library', 'Guidance Protocols', 'Integration Methods'],
  featured: true
}, {
  number: 'VOLUME 05',
  title: '📋 Professional Documentation & Assessment: Intake, Tracking & Progress',
  description: 'Client intake forms, anamnesis protocols, session documentation templates, progress tracking systems, professional record-keeping, and printable & editable resources.',
  tags: ['Intake Forms', 'Progress Tracking', 'Record Templates']
}, {
  number: 'VOLUME 06',
  title: '📓 The Interpretation Journal & Personal Evolution Tracker: Integration & Transformation',
  description: 'Post-session journaling protocols, pattern recognition systems, breakthrough documentation, monthly & annual reviews, client transformation tracking, and journal templates.',
  tags: ['Journaling Protocols', 'Transformation Tracking', 'Review Templates']
}];
export function Modules() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-144" data-mp="2rkrkta0x1a5w">
      <div className="mx-auto max-w-6xl" data-id="element-145" data-mp="2vmux20vesis8">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-146" data-mp="3jds0sqd1w9se">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-147" data-mp="3jc7690qqkquj">
            📚 6 Complete Premium <span className="text-sage" data-id="element-148" data-mp="3o5a0lb3c84bs">Reference Volumes</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-149" data-mp="1coq1m0lxfgcl">
            Every discipline decoded. Every correspondence mapped. Every tool ready to print and use
            today.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-150" data-mp="1mfue8to4qp49">
          {volumes.map((volume, index) => <Reveal key={volume.number} delay={index % 2 * 0.06} data-id="element-151" data-mp="1hfy9gs7lytnn" data-mpi={index}>
              <article className={`flex h-full flex-col rounded-2xl border bg-surface p-8 shadow-premium ${volume.featured ? 'border-amber/50' : 'border-navy/10'}`} data-id="element-152" data-mp="tqnig2g28dmp">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-sage" data-id="element-153" data-mp="13p3800zfveu3">
                  {volume.number}
                </p>
                <h3 className="mt-4 font-serif text-2xl leading-tight text-navy" data-id="element-154" data-mp="yrtby2hjo4xa">{volume.title}</h3>
                <p className="mt-4 flex-1 text-sm leading-7 text-slate" data-id="element-155" data-mp="2f630awlsdto4">{volume.description}</p>
                <ul className="mt-6 flex flex-wrap gap-2" data-id="element-156" data-mp="2a4lxuwnnlz5f">
                  {volume.tags.map(tag => <li key={tag} className="rounded-full bg-amber-pale px-3 py-1.5 text-xs font-semibold text-navy" data-id="element-157" data-mp="jpuxzloav96l">
                      {tag}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}